import { ModelPrs_SelectionChangedEvent } from '@cadexchanger/web-toolkit'
import { createStyles, makeStyles, Theme } from '@material-ui/core'
import { useContext, useEffect, useState } from 'react'
import { CadExContext } from '../context/CadExContext'
import { ModelNode } from '../types'
import { ModelExplorerItem } from './ModelExplorerItem'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      height: '70%',
      width: '384px',
      whiteSpace: 'pre-wrap',
      overflowY: 'auto',
      position: 'absolute',
      bottom: '24px',
      right: 0,
      boxShadow: theme.shadows['1'],
      zIndex: 2,
      overflowX: 'hidden',
      // padding: '1em',
      // backgroundColor: theme.palette.background.paper,
      // backgroundColor: theme.palette.action.hover,
      // opacity: 1,
      '& ul': {
        position: 'relative',
        '&::before': {
          content: '" "',
          position: 'absolute',
          bottom: 0,
          right: 0,
          left: 0,
          top: 0,
          height: '100%',
          // backgroundColor: 'pink',
          backgroundColor: theme.palette.background.paper,
          opacity: 0.8,
          zIndex: -1,
        },
      },
    },
  })
)

export const ModelExplorer = () => {
  const { getContext } = useContext(CadExContext)
  const { treeModel, viewPort, scene } = getContext()

  const [currentTreeModel, setCurrentTreeModel] = useState([])
  const cn = useStyles()

  const handleTreeNodeItemSelection = (
    item: ModelNode,
    multiSelection: boolean
  ) => {
    if (!item?.view3dObject) return

    const newSelectionState = !item.selected

    if (!multiSelection) {
      Array.from(treeModel).forEach(([key, item]) => {
        treeModel.set(key, Object.assign(item, { selected: false }))
      })
      scene.deselectAll()
    }

    if (!newSelectionState) {
      scene.deselect(item.view3dObject, true)
      setCurrentTreeModel(Array.from(treeModel))
      return
    }

    item.selected = newSelectionState

    scene.select(item.view3dObject, false, false)

    viewPort.changeCamera({
      ...viewPort.getCameraProperties(),
      position: { ...item.view3dObject['aa']?.position },
    })

    setCurrentTreeModel(Array.from(treeModel))
  }

  const handleSelectionChanged = (theEvent: ModelPrs_SelectionChangedEvent) => {
    if (!treeModel.size) return

    theEvent.removed.forEach((removed) => {
      const item = treeModel.get(removed.object['id'])

      item && Object.assign(item, { selected: false })
    })

    theEvent.added.forEach((added) => {
      const item = treeModel.get(added.object['id'])
      item && Object.assign(item, { selected: true })
    })

    setCurrentTreeModel(Array.from(treeModel))
  }

  useEffect(() => {
    if (!treeModel) return

    const collection =
      treeModel.size > 2
        ? Array.from(treeModel).map(([key, item]) => [
            key,
            Object.assign(item, { selected: !!item.selected }),
          ])
        : []

    scene.removeEventListener('selectionChanged', handleSelectionChanged)
    scene.addEventListener('selectionChanged', handleSelectionChanged)

    setCurrentTreeModel(collection)
    // eslint-disable-next-line
  }, [treeModel])

  return (
    currentTreeModel.length > 2 && (
      <nav className={cn.root}>
        <ul>
          {currentTreeModel.map(([key, item]) => (
            <ModelExplorerItem
              key={key.toString()}
              item={item}
              onItemSelected={handleTreeNodeItemSelection}
            />
          ))}
        </ul>
      </nav>
    )
  )
}
